import { postWithAuth, getWithAuth, putWithAuth } from '../../Basic/HttpService';

export const getAllServiceAgentDash = async () => {
    let res = await getWithAuth(`ServiceAgentDashboard`);
    return res;
};
